import React, {useEffect, useState} from "react";
import {FlexColumnCentered} from "../../../../components/ui/Content";
import {ButtonDefault, ButtonPrimary} from "../../../../components/ui/Button";
import {FormTitle, RecoveryEmailInfo} from "../../../../components/Font";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {
    ButtonContainer,
    ErrorSpan,
    InputSpan,
    RecoveryInputContainer,
    RegisterInputContainer
} from "../../../../components/ui/InputSearch";
import {useTheme} from "styled-components";
import { setChangeDataModal, setChangeDataModalDataForChange} from "../api/slice";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../../ui/Loader/MiniLoader";
import PhoneInput, {isValidPhoneNumber} from "react-phone-number-input";
import {InputPhone} from "../../../../ui/Input/InputPhone";
import ru from "react-phone-number-input/locale/ru.json";
import {DataForChange} from "../../../../enum/personalInfo";
import {ChangeDataModalInit} from "../../../../interface/Passport/Account/frontend";
import {addErrorEnter, cleanErrorEnter, InitiateChangeData, setChangeDataForChangeNull, setChangeSuccessFalse} from "../UserInfo/slice";


export const EnterPhoneForm = () => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch()
    const Theme = useTheme()
    const [phone, setPhone] = useState('')
    const {isFetching} = useAppSelector(state => state.user)
    const {error,setChangeDataForChange} = useAppSelector(state => state.user)


    const [phoneError, setPhoneError] = useState(false)

    const phoneSubmit = () => {
        if (phoneError) {
            dispatch(addErrorEnter({key: 'data', value: t('auth.enterValidPhone')}))
        } else {
            dispatch(InitiateChangeData(
                {
                    data: phone,
                    type_id: DataForChange.phone
                }
            ))
        }
    }

    useEffect(() => {
        dispatch(setChangeDataModalDataForChange(setChangeDataForChange))
    }, [setChangeDataForChange])

    const closeModal = () => {
        dispatch(setChangeDataModal(ChangeDataModalInit))
        dispatch(setChangeSuccessFalse())
        dispatch(setChangeDataForChangeNull())
    }

    return <>
        <FlexColumnCentered style={{width: '100%', marginTop: '10px'}}>
            <FormTitle>Введите новый номер</FormTitle>
            <RecoveryEmailInfo style={{textAlign: 'center', width: '270px'}}>
                Ваш номер телефона будет использоваться для входа в аккаунт
            </RecoveryEmailInfo>
        </FlexColumnCentered>
        <RegisterInputContainer style={{marginTop: 28}}>
            <RecoveryInputContainer >
                <RegisterInputContainer style={{border: error['data'] ? '1px solid red':''}}>
                    <PhoneInput
                        id={'registerPhoneInput'}
                        className={'PhoneInput'}
                        countrySelectComponent={InputPhone}
                        countrySelectProps={{unicodeFlags: true}}
                        error={error['data']}
                        international
                        countryCallingCodeEditable={false}
                        limitMaxLength={true}
                        labels={ru}
                        defaultCountry="RU"
                        value={phone}
                        onKeyDown={(e: React.KeyboardEvent) => {
                            if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                                phoneSubmit()
                            }
                        }
                        }
                        onChange={value => {
                            dispatch(cleanErrorEnter('data'));
                            if (value) {
                                setPhoneError(!isValidPhoneNumber(value))
                                setPhone(value.toString())
                            }else {
                                setPhone('')
                            }
                        }}/>
                    <InputSpan>
                        Номер телефона
                    </InputSpan>
                </RegisterInputContainer>
                {error['data'] && <ErrorSpan>
                    {error['data']}
                </ErrorSpan>}
            </RecoveryInputContainer>
        </RegisterInputContainer>
        <ButtonContainer style={{marginTop: '34px'}}>
            <ButtonDefault style={{width: '165px'}} onClick={closeModal}>Отмена</ButtonDefault>
            {isFetching
                ? <ButtonPrimary style={{
                    width: '165px',
                    marginLeft: '20px'

                }} disabled={isFetching}>
                    <LoaderContainer>
                        <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                    </LoaderContainer>
                </ButtonPrimary>
                : <ButtonPrimary
                    disabled={phone.length < 12}
                    onClick={phoneSubmit}
                    style={{
                        width: '165px',
                        marginLeft: '20px'
                    }}>
                    {t('auth.continue')}
                </ButtonPrimary>}
        </ButtonContainer>
    </>
}
